import React from "react";
import {Navigate} from "react-router-dom";

export const RouteError = () => {
    return <Navigate to={'/'}/>
}
